import { Link, useLocation } from "react-router-dom";
import style from "./ModalAppsItem.module.css";
import MoodleAuthApi from "../../../../services/MoodleAuthApi";
import Cookies from "js-cookie";

function TopbarItem({ texto, link, logo, aoFechar }) {
  const location = useLocation();
  const linkAtivo = location.pathname.startsWith(link);

  const handleClick = async (e) => {
    if (texto === "Plataforma") {
      e.preventDefault();
      
      try {
        const moodleToken = await MoodleAuthApi.autenticarMoodle();
        
        if (moodleToken && moodleToken.token) {
          
          Cookies.set('moodle_token', moodleToken.token, { 
            expires: 1/6,
            secure: true,
            sameSite: 'strict'
          });
          window.open(link, '_blank');
          if (aoFechar) aoFechar();
        } else {
          window.open(link, '_blank');
          if (aoFechar) aoFechar();
        }
      } catch (error) {
        console.error('Erro ao autenticar no Moodle:', error);
        window.open(link, '_blank');
        if (aoFechar) aoFechar();
      }
    }
    if (aoFechar) aoFechar();
  };

  return (
    <Link
      to={link}
      className={`${style.topbar_item} ${linkAtivo ? style.link_ativo : ""}`}
      onClick={handleClick}
    >
      {logo}
      <h3 className={style.texto_link}>{texto}</h3>
    </Link>
  );
}

export default TopbarItem;
